<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header" [afTranslate]="'duplicate-evaluation.duplicate-implantation'">Duplicar implantación</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content">
    @if (duplicateEvaluation.specialModal) {
      <p class="common-modal__content-header-info"
        [afTranslate]="'duplicate-evaluation.info-duplication'">_Solo se permite duplicar, con objeto de retomar su revisión, las evaluaciones finalizadas (excepto las No admitidas). Los formularios volverán a ser editables y la información del Sujeto Obligado y del Cliente se actualizará con los datos centralizados.</p>
    }
    <div class="common-modal__form-container">
      <div class="common-container__mandatory-obligatory-message-form">
        <span class="common-tag__mandatory-text-asterisk">*</span>
        <span class="common-tag__mandatory-label-text-obligatory-message"
          [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
      </div>
      @if (!duplicateEvaluation.specialModal) {
        <field-type-list-simple
          [field]="duplicateEvaluation.clientInfo"
          [preSelectItem]="duplicateEvaluation.newEvaluation.client"
          [listValues]="duplicateEvaluation.clientList"
          (itemSelected)="itemSelected('client', $event.newValue)"></field-type-list-simple>
      }
      <field-type-text-simple
        [field]="duplicateEvaluation.evaluationInfo"
        [preSelectItem]="duplicateEvaluation.newEvaluation.name"
        (itemSelected)="itemSelected('name', $event.newValue)">
      </field-type-text-simple>
      @if (!duplicateEvaluation.specialModal) {
        <field-type-switch [field]="{label: 'duplicate-evaluation.keep-content'|afTranslate}"
          [small]="true"
          [preSelectItem]="duplicateEvaluation.newEvaluation.preserveContent"
          (itemSelected)="duplicateEvaluation.newEvaluation.preserveContent = $event.newValue">
        </field-type-switch>
      }
    </div>
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="validateInfo()">
      <span class="common-button__text-title"
        [afTranslate]="'common.duplicate'">Duplicar</span>
    </button>
  </div>
</div>
